export default "__VITE_ASSET__B94Bph5x__"